import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const PaymentModeAPI = createApi({
  reducerPath: "PaymentModeAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,
    prepareHeaders: (headers, { endpoint }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      if (!["updatePaymentMode"].includes(endpoint)) {
        headers.set("Content-Type", "application/json");
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addPaymentMethod: builder.mutation({
      query: (formData) => ({
        url: "admin/payment-modes/",
        method: "POST",
        body: formData,
      }),
    }),

    updatePaymentMode: builder.mutation({
      query: ({ formData, id }) => ({
        url: `admin/payment-modes/${id}`,
        method: "POST",
        body: formData,
      }),
    }),

    getPaymentList: builder.query({
      query: () => `admin/payment-modes`,
    }),

    decryptData: builder.mutation({
      query: (encryptedData) => ({
        url: "decrypt",
        method: "POST",
        body: { token: encryptedData },
      }),
    }),
  }),
});

export const {
  useAddPaymentMethodMutation,
  useGetPaymentListQuery,
  useUpdatePaymentModeMutation,
  useDecryptDataMutation,
} = PaymentModeAPI;
